import { render, staticRenderFns } from "./PaymentAdmin.vue?vue&type=template&id=2c36983b&scoped=true"
import script from "./PaymentAdmin.vue?vue&type=script&lang=js"
export * from "./PaymentAdmin.vue?vue&type=script&lang=js"
import style0 from "./PaymentAdmin.vue?vue&type=style&index=0&id=2c36983b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36983b",
  null
  
)

export default component.exports